<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MUWkhA/tc-custom/9780544177703.jpg?1704313208799" alt="This image is the cover for the book Quick & Healthy Meals, Betty Crocker Cooking"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Quick & Healthy Meals, Betty Crocker Cooking
      </h1>
      <p class="bookDescription body article font2">
        <b>Healthy Eating is a breeze with Betty Crocker!</b><br/><br/> Want to fix healthy meals but don't have a lot of time? Don't worry! Inside you'll find over twenty Betty Crocker recipes that are great-tasting, good for you—and take thirty minutes or less to put on the table. All dishes are low in saturated fat, and main courses have no more than 420 calories. Delicious, healthy meals have never been easier!<br/><br/> For more great ideas visit bettycrocker.com
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Betty Crocker
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9de4a998